var map = {
	"./apps/core/locales/CAC/es.json": "d896",
	"./apps/core/locales/PNG/en.json": "c3b7",
	"./apps/core/locales/PNG/es.json": "1311",
	"./apps/core/locales/en.json": "b299",
	"./apps/core/locales/es.json": "e4e2",
	"./lib/uncrudtable/locales/en.json": "07e6",
	"./lib/uncrudtable/locales/es.json": "7a11",
	"./lib/unlogin/locales/en.json": "c5b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "805f";